/* eslint-disable */
import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import * as API from "../../framework/API/api";
import { ENTITYNAME, TOAST_TYPES } from "../../framework/constant/constant";
import ActionButton from "../../framework/forms/helpercomponents/buttons/ActionButton";
import ToastNotification from "../../components/ToastNotification";
import BossDialog from "../../components/BossDialog";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import moment from "moment";
import { useTranslation } from "../../locale/useTranslation";
import { utility } from "../../framework/utility/utilityProvider";
import MyMultiSelect from "../../components/MyMultiSelect";

const issueTableHeaderStyle = {
    padding: "8px 12px",
    textAlign: "left",
    fontWeight: "600",
    color: "#495057",
    borderBottom: "2px solid #dee2e6",
    whiteSpace: "nowrap"
};

const issueTableCellStyle = {
    padding: "9px 12px",
    textAlign: "left",
    verticalAlign: "middle"
};

const CheckPlanningOverlapOrGapPopup = (props) => {
    const lang = useTranslation();

    const [dataItem, setDataItem] = useState({
       fromDate: moment().startOf('month').format('YYYY-MM-DD'),
       toDate: moment().endOf('month').format('YYYY-MM-DD'),
       channel: []
    })

    const [channels, setChannels] = useState([]);
    const [loading, setLoading] = useState(false);
    const [resultData, setResultData] = useState(null);
    const [channelIssuesData, setChannelIssuesData] = useState([]);
    const [noDataChannels, setNoDataChannels] = useState([]);
    const [cleanChannels, setCleanChannels] = useState([]);

    useEffect(() => {
        loadCombo();
    }, []);

    const loadCombo = async () => {
        const channelRes = await API.getDataLookup(ENTITYNAME.Channel, { sort: { FullChannelName: 1 } });
        setChannels(channelRes?.data);
        setDataItem({ ...dataItem, channel: channelRes?.data[0] });
    }


    const onChange = (e) => {
        const { name, value } = e.target;
        setDataItem({ ...dataItem, [name]: value });
    };

    const onSubmit = async () => {
        
        if (!dataItem.channel?.length) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang?.invalid_error_message_title || "Error", message: "Please select a Channel" });
            return;
        }
        if (!dataItem?.fromDate || !dataItem?.toDate) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang?.invalid_error_message_title || "Error", message: "Please select From Date and To Date" });
            return;
        }

        setLoading(true);

        const channelSids = dataItem?.channel?.map(ch => ch.SID);
        const payload = {
            payload: {
                fromDate: new Date(dataItem?.fromDate).getTime(),
                toDate: new Date(dataItem?.toDate).getTime(),
                channelSIDs: channelSids
            }
        };

        setResultData(null);
        setChannelIssuesData([]);
        setNoDataChannels([]);
        setCleanChannels([]);

        const res = await API.checkPlanningOverlapOrGap(payload);
        console.log(res);
        setLoading(false);
        setResultData(res);

        if (Array.isArray(res?.data)) {
            const issuesList = [];
            const noDataList = [];
            const cleanList = [];

            res.data.forEach(item => {
                const issues = Array.isArray(item.issues) ? item.issues : (item.issues?.issues || []);

                if (item.success) {
                    cleanList.push(item.channelName || `Channel ${item.channelSID}`);
                } else if (issues.length > 0) {
                    issuesList.push({
                        channelName: item.channelName || "Unknown Channel",
                        channelSID: item.channelSID,
                        issues: issues,
                        totalIssues: issues.length
                    });
                } else {
                    noDataList.push(item.channelName || `Channel ${item.channelSID}`);
                }
            });

            setChannelIssuesData(issuesList);
            setNoDataChannels(noDataList);
            setCleanChannels(cleanList);
        }
    };

    const content = (
        <div style={{ padding: "8px 0" }}>
            {/* Controls Filter Row */}
            <div style={{
                padding: "16px",
                background: "#f8f9fa",
                border: "1px solid #dee2e6",
                marginBottom: "16px",
                borderRadius: "8px"
            }}>
                <div className="row align-items-center">
                    <div className="col-md-4">
                        <label style={{ fontSize: "12px", fontWeight: "600", color: "#495057", marginBottom: "4px", display: "block" }}>
                            {lang?.channel_label} *
                        </label>
                        <MyMultiSelect
                            style={{ backgroundColor: "white", width: "100%" }}
                            data={channels}
                            name="channel"
                            textField="FullChannelName"
                            dataItemKey="SID"
                            value={dataItem.channel}
                            onChange={onChange}
                        />
                    </div>
                    <div className="col-md-3">
                        <label style={{ fontSize: "12px", fontWeight: "600", color: "#495057", marginBottom: "4px", display: "block" }}>
                            {lang?.from_date_label} *
                        </label>
                        <input
                            type="date"
                            className="form-control form-control-sm"
                            name="fromDate"
                            value={dataItem?.fromDate}
                            onChange={onChange}
                        />
                    </div>
                    <div className="col-md-3">
                        <label style={{ fontSize: "12px", fontWeight: "600", color: "#495057", marginBottom: "4px", display: "block" }}>
                            {lang?.to_date_label} *
                        </label>
                        <input
                            type="date"
                            className="form-control form-control-sm"
                            name="toDate"
                            value={dataItem?.toDate}
                            onChange={onChange}
                        />
                    </div>
                    <div className="col-md-2" style={{ marginTop: "22px" }}>
                        <ActionButton
                            title={lang?.show_button_tooltip}
                            name={lang?.show_button_tooltip}
                            onClick={onSubmit}
                        />
                    </div>
                </div>
            </div>

            {/* Loading State */}
            {loading && (
                <div style={{ textAlign: "center", padding: "40px 0" }}>
                    <i className="fa fa-spinner fa-spin" style={{ fontSize: "28px", color: "#3498db" }}></i>
                    <div style={{ marginTop: "10px", color: "#6c757d", fontWeight: "500" }}>
                        {lang.checking_planning_for_gaps_and_overlaps_label}
                    </div>
                </div>
            )}

            {/* Results Display */}
            {!loading && resultData && (
                <div>
                    {/* 1. Channels with No Planning Data */}
                    {noDataChannels.length > 0 && (
                        <div style={{ display: "flex", alignItems: "center", background: "#fffbeb", border: "1px solid #fde68a", borderRadius: "8px", padding: "12px 16px", marginBottom: "14px" }}>
                            <span style={{ fontSize: "20px", marginRight: "10px", display: "flex", alignItems: "center" }}>ℹ️</span>
                            <div>
                                <strong style={{ color: "#b45309", fontSize: "14px" }}>No Planning Data Found: </strong>
                                <span style={{ color: "#854d0e", fontSize: "14px" }}>{noDataChannels.join(", ")}</span>
                            </div>
                        </div>
                    )}

                    {/* 2. Clean Channels */}
                    {cleanChannels.length > 0 && (
                        <div style={{ display: "flex", alignItems: "center", background: "#f0fff4", border: "1px solid #86efac", borderRadius: "8px", padding: "12px 16px", marginBottom: "14px" }}>
                            <span style={{ fontSize: "20px", marginRight: "10px", display: "flex", alignItems: "center" }}>✅</span>
                            <div>
                                <strong style={{ color: "#15803d", fontSize: "14px" }}>No Gaps or Overlaps Found: </strong>
                                <span style={{ color: "#166534", fontSize: "14px" }}>{cleanChannels.join(", ")}</span>
                            </div>
                        </div>
                    )}

                    {/* 3. Detailed Table for Channels with Gaps or Overlaps */}
                    {channelIssuesData.length > 0 && (
                        <div style={{ maxHeight: "380px", overflowY: "auto", overflowX: "hidden", paddingRight: "4px" }}>
                            {channelIssuesData.map((channel, chIdx) => (
                                <div key={chIdx} style={{
                                    marginBottom: "18px", border: "1px solid #e0e0e0",
                                    borderRadius: "8px", overflow: "hidden",
                                    boxShadow: "0 1px 4px rgba(0,0,0,0.06)"
                                }}>
                                    {/* Channel Header */}
                                    <div style={{
                                        display: "flex", alignItems: "center", justifyContent: "space-between",
                                        padding: "10px 16px",
                                        background: "linear-gradient(135deg, #2c3e50 0%, #34495e 100%)",
                                        color: "#fff"
                                    }}>
                                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                            <span style={{ fontSize: "16px" }}>📺</span>
                                            <strong style={{ fontSize: "14px" }}>{channel.channelName}</strong>
                                        </div>
                                        <span style={{
                                            fontSize: "11px", background: "#e74c3c",
                                            padding: "3px 10px", borderRadius: "12px", fontWeight: "600"
                                        }}>
                                            {channel.totalIssues} {channel.totalIssues === 1 ? 'Issue' : 'Issues'}
                                        </span>
                                    </div>

                                    {/* Issues Table */}
                                    <div style={{ overflowX: "auto" }}>
                                        <table style={{
                                            width: "100%", borderCollapse: "collapse",
                                            fontSize: "12.5px"
                                        }}>
                                            <thead>
                                                <tr style={{ background: "#f8f9fa", position: "sticky", top: 0, zIndex: 1 }}>
                                                    <th style={issueTableHeaderStyle}>#</th>
                                                    <th style={issueTableHeaderStyle}>Type</th>
                                                    <th style={issueTableHeaderStyle}>Program 1</th>
                                                    <th style={issueTableHeaderStyle}>Start Time</th>
                                                    <th style={issueTableHeaderStyle}>End Time</th>
                                                    <th style={issueTableHeaderStyle}>Program 2</th>
                                                    <th style={issueTableHeaderStyle}>Start Time</th>
                                                    <th style={issueTableHeaderStyle}>Duration</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {channel.issues.map((issue, issIdx) => {
                                                    const isGap = issue.type === 'gap' || issue.issueType === 'gap';
                                                    const title1 = issue.titles?.[0] || issue.title || issue.program1 || issue.prevTitle || '—';
                                                    const start1 = issue.startTimes_str || (issue.startTime ? moment(issue.startTime).format('YYYY-MM-DD HH:mm:ss') : '—');
                                                    const end1 = issue.endTime_str || (issue.endTime ? moment(issue.endTime).format('YYYY-MM-DD HH:mm:ss') : '—');
                                                    const title2 = issue.titles?.[1] || issue.title2 || issue.program2 || issue.nextTitle || '—';
                                                    const start2 = issue.startTimes2_str || (issue.startTime2 ? moment(issue.startTime2).format('YYYY-MM-DD HH:mm:ss') : '—');
                                                    const duration = issue.gapDuration_str || issue.overlapBy_str || (issue.duration ? utility.convertMilisecondsToStringWithFrames(issue.duration) : '—');

                                                    return (
                                                        <tr key={issIdx} style={{
                                                            borderBottom: "1px solid #eee",
                                                            background: issIdx % 2 === 0 ? "#fff" : "#fafbfc"
                                                        }}>
                                                            <td style={issueTableCellStyle}>{issIdx + 1}</td>
                                                            <td style={issueTableCellStyle}>
                                                                <span style={{
                                                                    display: "inline-block",
                                                                    padding: "3px 10px",
                                                                    borderRadius: "12px",
                                                                    fontSize: "11px",
                                                                    fontWeight: "600",
                                                                    textTransform: "capitalize",
                                                                    background: isGap ? "#fff3cd" : "#f8d7da",
                                                                    color: isGap ? "#856404" : "#721c24",
                                                                    border: isGap ? "1px solid #ffc107" : "1px solid #f5c6cb"
                                                                }}>
                                                                    {isGap ? '⏸ Gap' : '⚡ Overlap'}
                                                                </span>
                                                            </td>
                                                            <td style={{ ...issueTableCellStyle, fontWeight: "500" }}>
                                                                {title1}
                                                            </td>
                                                            <td style={{ ...issueTableCellStyle, color: "#6c757d", fontFamily: "monospace", fontSize: "11.5px" }}>
                                                                {start1}
                                                            </td>
                                                            <td style={{ ...issueTableCellStyle, color: "#6c757d", fontFamily: "monospace", fontSize: "11.5px" }}>
                                                                {end1}
                                                            </td>
                                                            <td style={{ ...issueTableCellStyle, fontWeight: "500" }}>
                                                                {title2}
                                                            </td>
                                                            <td style={{ ...issueTableCellStyle, color: "#6c757d", fontFamily: "monospace", fontSize: "11.5px" }}>
                                                                {start2}
                                                            </td>
                                                            <td style={issueTableCellStyle}>
                                                                <span style={{
                                                                    fontWeight: "700",
                                                                    color: isGap ? "#e67e22" : "#c0392b"
                                                                }}>
                                                                    {duration}
                                                                </span>
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            )}
        </div>
    );

    return (
        <BossDialog
            title={lang.check_planning_gaps_overlaps_dialogue_header}
            onClose={props.onClose}
            width={props.width || "1100px"}
        >
            {content}
        </BossDialog>
    );
};

export default CheckPlanningOverlapOrGapPopup;
